import { type ReactElement, type ReactNode } from 'react';
import { SurfaceHeader } from '@citibox-panel/ui';

export interface PageHeaderProps {
  // The market this deployment writes against, resolved by the host: each deployment reaches only
  // its own app-service, so the label is what tells an engineer WHICH network they are about to
  // change. It belongs on the chrome, not only on a confirmation.
  brandLabel: string;
  brandDegraded: boolean;
  // The host's own chrome — the user menu, and with it the only way to sign out of this screen.
  headerEnd?: ReactNode;
}

// The chrome band of the operations surfaces, shared by this module's slices. It used to be written
// out here, duplicated on purpose beside the search shell's while two surfaces were only an
// observation; a third surface appeared, so the band now lives in the façade and this file only names
// what the operations surfaces put in it. Its props stay so the pages composing it do not change.
//
// What these surfaces do NOT carry is the search field, the «nueva búsqueda» affordance and the tab
// strip: there is no entity here and nothing to search for, so the centre zone stays empty rather
// than present and inert.
export function PageHeader({ brandLabel, brandDegraded, headerEnd }: PageHeaderProps): ReactElement {
  return <SurfaceHeader brandLabel={brandLabel} brandDegraded={brandDegraded} end={headerEnd} />;
}
